<template>
  <component
    :is="iconComponent"
    v-if="iconComponent"
    :size="size"
    :stroke-width="strokeWidth"
    :color="color"
    :aria-hidden="ariaHidden"
    :class="['icon', className]"
  />
</template>

<script>
import * as LucideIcons from 'lucide-vue-next';

/**
 * Icon — thin wrapper around lucide-vue-next that enforces consistent
 * sizing/stroke across the whole application.
 *
 * Usage:
 *   <Icon name="Lightbulb" />
 *   <Icon name="Plus" :size="16" />
 */
export default {
  name: 'BaseIcon',
  props: {
    name: { type: String, required: true },
    size: { type: [Number, String], default: 18 },
    strokeWidth: { type: [Number, String], default: 1.75 },
    color: { type: String, default: 'currentColor' },
    ariaHidden: { type: Boolean, default: true },
    className: { type: String, default: '' },
  },
  computed: {
    iconComponent() {
      // lucide-vue-next exports icons in PascalCase (e.g. `Lightbulb`, `Plus`).
      return LucideIcons[this.name] || LucideIcons.HelpCircle;
    },
  },
};
</script>

<style scoped>
.icon {
  display: inline-block;
  flex-shrink: 0;
  vertical-align: middle;
}
</style>
